import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../../assets/images/user/user3.jpg'


const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = {
  class: "position-relative",
  style: {"min-width":"220px","max-width":"300px","flex":"1 1 auto"}
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_28 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_29 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_31 = { class: "dropdown" }
const _hoisted_32 = { class: "dropdown-menu" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  colspan: "9",
  class: "text-center py-20"
}
const _hoisted_39 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_40 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_41 = { class: "fw-bold" }
const _hoisted_42 = { class: "fw-bold" }
const _hoisted_43 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_44 = { class: "fw-bold" }
const _hoisted_45 = { class: "fw-bold" }
const _hoisted_46 = { class: "mt-15 mt-md-0" }
const _hoisted_47 = { class: "pagination mb-0" }
const _hoisted_48 = {
  key: 0,
  class: "page-item"
}
const _hoisted_49 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 1,
  class: "page-item"
}
const _hoisted_52 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_53 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_54 = { class: "modal-content" }
const _hoisted_55 = { class: "modal-header" }
const _hoisted_56 = { class: "modal-title fs-5" }
const _hoisted_57 = { class: "modal-body" }
const _hoisted_58 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_59 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_60 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_61 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_62 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_66 = ["placeholder"]
const _hoisted_67 = { class: "invalid-feedback" }
const _hoisted_68 = { class: "col-md-6" }
const _hoisted_69 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_70 = ["placeholder"]
const _hoisted_71 = { class: "invalid-feedback" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-md-6" }
const _hoisted_74 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_75 = { class: "invalid-feedback" }
const _hoisted_76 = { class: "col-md-6" }
const _hoisted_77 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_78 = ["placeholder"]
const _hoisted_79 = { class: "invalid-feedback" }
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-md-6" }
const _hoisted_82 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_83 = ["placeholder"]
const _hoisted_84 = { class: "invalid-feedback" }
const _hoisted_85 = { class: "col-md-6" }
const _hoisted_86 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_87 = ["placeholder"]
const _hoisted_88 = { class: "invalid-feedback" }
const _hoisted_89 = { class: "row" }
const _hoisted_90 = { class: "col-md-6" }
const _hoisted_91 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_92 = ["selected"]
const _hoisted_93 = ["selected"]
const _hoisted_94 = { class: "col-md-6" }
const _hoisted_95 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_96 = ["selected"]
const _hoisted_97 = ["selected"]
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "col-md-6" }
const _hoisted_100 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_101 = ["placeholder"]
const _hoisted_102 = { class: "invalid-feedback" }
const _hoisted_103 = { class: "col-md-6" }
const _hoisted_104 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_105 = ["placeholder"]
const _hoisted_106 = { class: "invalid-feedback" }
const _hoisted_107 = { class: "row" }
const _hoisted_108 = { class: "col-md-12" }
const _hoisted_109 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_110 = ["placeholder"]
const _hoisted_111 = { class: "invalid-feedback" }
const _hoisted_112 = { class: "modal-footer" }
const _hoisted_113 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}

import { ref, onMounted, reactive, inject, computed, watch } from "vue";
import axios from 'axios';
import conf from '../../../../env.json';
import { useI18n } from "vue-i18n";
import router from '../../../router/index'
import { current_permissions } from '../../../utils/permission';
import { useRouter } from 'vue-router';
import * as yup from 'yup';
import { validate_phone_number, showToast, checkSessionValidate } from "../../../utils/function";
import { Organization } from "@/utils/Model";

const itemsPerPage = 10;

export default /*@__PURE__*/_defineComponent({
  __name: 'CustomersList',
  setup(__props) {

const backApi = inject('back');

const page = ref(1);

const gettran = ref(false);
const search = ref(false);
const search1 = ref(false);
const selectedValidation = ref('N');
const selected = ref(false);
const selectedType = ref('LEGAL');
const { t } = useI18n();
let edit = 0;
let itemCode = '';
const errorId = ref('');
let token: string | null = localStorage.getItem('login_token');

function handleValidationChange(event) {
  selectedValidation.value = event.target.value;
}

function handleTypeChange(event) {
  selectedType.value = event.target.value;
}

const searchQuery = ref('');

const allOrganizations = ref(new Array<Organization>());

const filteredOrganizations = computed(() => {
  if (!searchQuery.value.trim()) return allOrganizations.value;
  const q = searchQuery.value.toLowerCase();
  return allOrganizations.value.filter((o: any) => {
    return [
      o.name,
      o.bankDomiciliation,
      o.rib,
      o.cryptoAccount,
      o.email,
      o.maxPayoutAmount ? String(o.maxPayoutAmount) : '',
      o.payoutValidationDelay ? String(o.payoutValidationDelay) : '',
      o.status === 'ACTIVE' ? t('organizations.active') : o.status === 'INACTIVE' ? t('organizations.inactive') : ''
    ].some(field => field?.toLowerCase().includes(q));
  });
});

const filteredTotal = computed(() => filteredOrganizations.value.length);

const numPages = computed(() => Math.max(1, Math.ceil(filteredTotal.value / itemsPerPage)));

const paginatedOrganizations = computed(() => {
  const start = (page.value - 1) * itemsPerPage;
  return filteredOrganizations.value.slice(start, start + itemsPerPage);
});

watch(searchQuery, () => {
  page.value = 1;
});

watch(numPages, (newNumPages) => {
  if (page.value > newNumPages) {
    page.value = newNumPages;
  }
});

const changePage = (numPage: number) => {
  if (numPage < 1 || numPage > numPages.value) return;
  page.value = numPage;
};

const errors = ref('');
const success = ref('');
const errorsBis = {
  'name': '',
  'description': '',
  'email': '',
  'contact': '',
  'bankDomiciliation': '',
  'rib': '',
  'cryptoAccount': '',
  'maxPayoutAmount': '',
  'payoutValidationDelay': ''
};
const pageLoad = ref(false);

const formValues = reactive({
  email: "",
  description: "",
  name: "",
  contact: "",
  bankDomiciliation: "",
  rib: "",
  cryptoAccount: "",
  maxPayoutAmount: 0,
  payoutValidationDelay: 0
});

const phoneRegExp = /^((\\+[0-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const schema = yup.object({
  email: yup.string().email('l\'e-mail doit être un e-mail valide').required('L\'email est requis'),
  name: yup.string().required('La raison sociale est requise'),
  description: yup.string().required('La description est requise'),
  contact: yup.string().required('Le numéro de téléphone est requis').matches(phoneRegExp, "Veuillez saisir un numéro de telephone valide").test('len', "Le numero de téléphone doit faire exactement 10 chiffres", val => val && val.length === 10),
  bankDomiciliation: yup.string().required('Le nom de la banque est requis'),
  rib: yup.string().required('Le RIB est requis'),
  cryptoAccount: yup.string(),
  maxPayoutAmount: yup.number().min(0, 'Le montant doit être positif').nullable(),
  payoutValidationDelay: yup.number().min(0, 'Le délai doit être positif').nullable()
});

function formatDateFr(value) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;
  }
}

const showScreen = (code) => {
  itemCode = code;
}

const initField = () => {
  formValues.name = '';
  formValues.contact = '';
  formValues.email = '';
  formValues.description = '';
  formValues.bankDomiciliation = '';
  formValues.rib = '';
  formValues.cryptoAccount = '';
  formValues.maxPayoutAmount = 0;
  formValues.payoutValidationDelay = 0;
  selectedValidation.value = 'N';
  selected.value = false;
  selectedType.value = 'LEGAL';
  itemCode = '';
  edit = 0;
}

const cancel = () => {
  itemCode = "";
  errorId.value = "";
  errors.value = "";
}

const save = () => {
  if (edit == 0) {
    storeOrganization()
  } else {
    updateOrganization()
  }
}

const showOrganization = (code) => {
  axios.get(backApi + '/secure/organizations/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      formValues.name = response.data.name || '';
      formValues.description = response.data.description || '';
      formValues.contact = response.data.contact || '';
      formValues.email = response.data.email || '';
      formValues.bankDomiciliation = response.data.bankDomiciliation || '';
      formValues.rib = response.data.rib || '';
      formValues.cryptoAccount = response.data.cryptoAccount || '';
      formValues.maxPayoutAmount = response.data.maxPayoutAmount || 0;
      formValues.payoutValidationDelay = response.data.payoutValidationDelay || 0;

      selectedValidation.value = (response.data.validatePayoutBeforProcess) ? 'O' : 'N';
      selected.value = response.data.validatePayoutBeforProcess;
      selectedType.value = response.data.type || 'LEGAL';
      itemCode = response.data.code;
      edit = 1;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          console.log(error.response);
        }
      }
    });
}

const fetchOrganizationsPage = (pageNum: number) => {
  return axios.get(backApi + '/secure/organizations/' + pageNum, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

const loadAllOrganizations = () => {
  fetchOrganizationsPage(1)
    .then((response) => {
      const firstPageData = response.data.organizations || [];
      const totalPages = parseInt(response.data.pagination.numPages) || 1;

      if (totalPages <= 1) {
        allOrganizations.value = firstPageData;
        return;
      }

      const requests = [];
      for (let p = 2; p <= totalPages; p++) {
        requests.push(fetchOrganizationsPage(p));
      }

      Promise.all(requests)
        .then((responses) => {
          let combined = [...firstPageData];
          responses.forEach((res) => {
            combined = combined.concat(res.data.organizations || []);
          });
          allOrganizations.value = combined;
        })
        .catch((error) => {
          console.log(error);
          allOrganizations.value = firstPageData;
        });
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const changeStatus = (status, code) => {
  axios.put(`${backApi}/secure/organizations/${code}/status`, {
    organization: code,
    status: (status == 'ACTIVE') ? 'INACTIVE' : 'ACTIVE'
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    if (response.status === 200) {
      showToast("Organisation activée avec succès", "green");
      router.go();
    }
  }).catch((error) => {
    if (error.response) {
      showToast(error.response.data.message, "red");
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const changevalidatePayout = (status, code) => {
  axios.put(`${backApi}/secure/payout-validation-process`, {
    validatePayoutBeforProcess: (status == 'ACTIVE') ? 'INACTIVE' : 'ACTIVE'
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    if (response.status === 200) {
      showToast("Organisation activée avec succès", "green");
      router.go();
    }
  }).catch((error) => {
    if (error.response) {
      showToast(error.response.data.message, "red");
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const storeOrganization = () => {
  try {
    schema.validateSync(formValues);
    axios.post(`${backApi}/secure/organizations/new`, {
      name: formValues.name,
      email: formValues.email,
      contact: formValues.contact,
      description: formValues.description,
      bankDomiciliation: formValues.bankDomiciliation,
      rib: formValues.rib,
      cryptoAccount: formValues.cryptoAccount,
      validatePayoutBeforProcess: (selectedValidation.value == 'N') ? false : true,
      type: selectedType.value,
      maxPayoutAmount: formValues.maxPayoutAmount || 0,
      payoutValidationDelay: formValues.payoutValidationDelay || 0
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Enregistrement effectué avec succès", "green");
        router.go();
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errors.value = error.response.data.message || 'Une erreur est survenue';
          showToast(errors.value, "red");
        }
      }
    });
  } catch (error) {
    console.error(error);
    errors.value = "une erreur inattendue est apparue"
  }
}

const updateOrganization = () => {
  try {
    schema.validateSync(formValues);
    axios.put(`${backApi}/secure/organizations/${itemCode}/edit`, {
      code: itemCode,
      name: formValues.name,
      email: formValues.email,
      contact: formValues.contact,
      description: formValues.description,
      bankDomiciliation: formValues.bankDomiciliation,
      rib: formValues.rib,
      cryptoAccount: formValues.cryptoAccount,
      validatePayoutBeforProcess: (selectedValidation.value == 'N') ? false : true,
      type: selectedType.value,
      maxPayoutAmount: formValues.maxPayoutAmount || 0,
      payoutValidationDelay: formValues.payoutValidationDelay || 0
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        router.go();
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errors.value = error.response.data.message || 'Une erreur est survenue';
          showToast(errors.value, "red");
        }
      }
    });
  } catch (error) {
    console.error(error);
    errors.value = "une erreur inattendue est apparue"
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;

    });
  errors.value = ''
}

onMounted(() => {
  checkSessionValidate(1)
  loadAllOrganizations();
  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[32] || (_cache[32] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_unref(current_permissions)('create_organization'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#companyModal",
                    style: {"background-color":"#EB9355"},
                    onClick: initField
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('organizations.createOrg')) + " ", 1),
                    _cache[33] || (_cache[33] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                type: "text",
                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                placeholder: _ctx.$t('organizations.search')
              }, null, 8, _hoisted_6), [
                [_vModelText, searchQuery.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('organizations.customerName')), 1),
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('organizations.bank')), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('organizations.rib')), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('organizations.cryptocurrency')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('organizations.email')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('organizations.maxPayoutAmount')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('organizations.payoutValidationDelay')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('organizations.status')), 1),
                    _cache[34] || (_cache[34] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedOrganizations.value, (organization) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: organization.id
                    }, [
                      _createElementVNode("th", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "form-check mb-0" }, [
                            _createElementVNode("input", {
                              class: "form-check-input shadow-none",
                              type: "checkbox"
                            })
                          ], -1)),
                          _createElementVNode("div", _hoisted_20, [
                            _cache[35] || (_cache[35] = _createElementVNode("img", {
                              src: _imports_0,
                              class: "rounded-circle me-8",
                              width: "24",
                              height: "24",
                              alt: "user"
                            }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(organization.name), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(organization.bankDomiciliation), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(organization.rib), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(organization.cryptoAccount), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(organization.email), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(organization.maxPayoutAmount ? organization.maxPayoutAmount + ' XOF' : '-'), 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(organization.payoutValidationDelay ? organization.payoutValidationDelay + ' min' : '-'), 1),
                      _createElementVNode("td", _hoisted_27, [
                        (organization.status==='ACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('organizations.active')), 1))
                          : _createCommentVNode("", true),
                        (organization.status==='INACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('organizations.inactive')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _cache[42] || (_cache[42] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_32, [
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('list_users'))
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: `/companyusers/${organization.code}`,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[37] || (_cache[37] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('organizations.users')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["to"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('show_account'))
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: `/account/${organization.code}`,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[38] || (_cache[38] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('organizations.accounts')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["to"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('show_fee'))
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: `/fees/${organization.code}`,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[39] || (_cache[39] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('organizations.fees')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["to"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('status_organization'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (changeStatus(organization.status,organization.code))
                                  }, [
                                    _cache[40] || (_cache[40] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                    (organization.status==='ACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.$t('organizations.deactivate')), 1))
                                      : _createCommentVNode("", true),
                                    (organization.status==='INACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('organizations.activate')), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_33))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('show_organization'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#companyModal",
                                    onClick: ($event: any) => (showOrganization(organization.code))
                                  }, [
                                    _cache[41] || (_cache[41] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('organizations.edit')), 1)
                                  ], 8, _hoisted_36))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128)),
                  (paginatedOrganizations.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                        _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.$t('organizations.noResult') || 'Aucun résultat'), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (filteredTotal.value>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  (filteredTotal.value>itemsPerPage)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_40, [
                        _createTextVNode(_toDisplayString(_ctx.$t('organizations.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_41, _toDisplayString(Math.min(page.value*itemsPerPage, filteredTotal.value)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('organizations.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('organizations.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (filteredTotal.value<=itemsPerPage)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                        _createTextVNode(_toDisplayString(_ctx.$t('organizations.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_44, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('organizations.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_45, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('organizations.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_46, [
                    _createElementVNode("ul", _hoisted_47, [
                      ((page.value-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (changePage(page.value-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[43] || (_cache[43] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numPages.value, (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==page.value)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_49, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (changePage(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_50))
                        ]))
                      }), 128)),
                      ((page.value+1)<=numPages.value)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (changePage(page.value+1))),
                              "aria-label": "Next"
                            }, [...(_cache[44] || (_cache[44] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(save, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("h1", _hoisted_56, _toDisplayString(_unref(edit) == 0 ? _ctx.$t('organizations.createOrg') : _ctx.$t('organizations.editTitle')), 1),
              _cache[45] || (_cache[45] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_57, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createElementVNode("h6", _hoisted_59, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createElementVNode("h6", _hoisted_61, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('organizations.companyName')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formValues.name) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('organizations.companyNamePlaceholder'),
                        onBlur: _cache[4] || (_cache[4] = ($event: any) => (validate('name'))),
                        onKeyup: _cache[5] || (_cache[5] = ($event: any) => (validate('name')))
                      }, null, 42, _hoisted_66), [
                        [_vModelText, formValues.name]
                      ]),
                      _createElementVNode("span", _hoisted_67, _toDisplayString(errorsBis['name']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('organizations.phone')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formValues.contact) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['contact'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('organizations.phonePlaceholder'),
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (_unref(validate_phone_number)($event.target.value,$event.target))),
                        onKeyup: _cache[8] || (_cache[8] = ($event: any) => (_unref(validate_phone_number)($event.target.value,$event.target))),
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (validate('contact')))
                      }, null, 42, _hoisted_70), [
                        [_vModelText, formValues.contact]
                      ]),
                      _createElementVNode("span", _hoisted_71, _toDisplayString(errorsBis['contact']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t('organizations.email')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formValues.email) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['email'] }]),
                        id: "lead-calendar",
                        placeholder: "info@imoney.africa",
                        onBlur: _cache[11] || (_cache[11] = ($event: any) => (validate('email'))),
                        onKeyup: _cache[12] || (_cache[12] = ($event: any) => (validate('email')))
                      }, null, 34), [
                        [_vModelText, formValues.email]
                      ]),
                      _createElementVNode("span", _hoisted_75, _toDisplayString(errorsBis['email']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t('organizations.cryptoAccount')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formValues.cryptoAccount) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['cryptoAccount'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('organizations.cryptoPlaceholder'),
                        onBlur: _cache[14] || (_cache[14] = ($event: any) => (validate('cryptoAccount'))),
                        onKeyup: _cache[15] || (_cache[15] = ($event: any) => (validate('cryptoAccount')))
                      }, null, 42, _hoisted_78), [
                        [_vModelText, formValues.cryptoAccount]
                      ]),
                      _createElementVNode("span", _hoisted_79, _toDisplayString(errorsBis['cryptoAccount']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t('organizations.bank')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formValues.bankDomiciliation) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['bankDomiciliation'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('organizations.bankPlaceholder'),
                        onBlur: _cache[17] || (_cache[17] = ($event: any) => (validate('bankDomiciliation'))),
                        onKeyup: _cache[18] || (_cache[18] = ($event: any) => (validate('bankDomiciliation'))),
                        onChange: _cache[19] || (_cache[19] = ($event: any) => (validate('bankDomiciliation')))
                      }, null, 42, _hoisted_83), [
                        [_vModelText, formValues.bankDomiciliation]
                      ]),
                      _createElementVNode("span", _hoisted_84, _toDisplayString(errorsBis['bankDomiciliation']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.$t('organizations.rib')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formValues.rib) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['rib'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('organizations.ribPlaceholder'),
                        onBlur: _cache[21] || (_cache[21] = ($event: any) => (validate('rib'))),
                        onKeyup: _cache[22] || (_cache[22] = ($event: any) => (validate('rib')))
                      }, null, 42, _hoisted_87), [
                        [_vModelText, formValues.rib]
                      ]),
                      _createElementVNode("span", _hoisted_88, _toDisplayString(errorsBis['rib']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.$t('organizations.requiresValidation')), 1),
                    _createElementVNode("select", {
                      name: "operator",
                      id: "operator",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleValidationChange,
                      required: ""
                    }, [
                      _createElementVNode("option", {
                        value: "N",
                        selected: selectedValidation.value=='N'
                      }, _toDisplayString(_ctx.$t('organizations.no')), 9, _hoisted_92),
                      _createElementVNode("option", {
                        value: "O",
                        selected: selectedValidation.value=='O'
                      }, _toDisplayString(_ctx.$t('organizations.yes')), 9, _hoisted_93)
                    ], 32)
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t('organizations.type')), 1),
                    _createElementVNode("select", {
                      name: "type",
                      id: "type",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleTypeChange,
                      required: ""
                    }, [
                      _createElementVNode("option", {
                        value: "LEGAL",
                        selected: selectedType.value=='LEGAL'
                      }, _toDisplayString(_ctx.$t('organizations.legal')), 9, _hoisted_96),
                      _createElementVNode("option", {
                        value: "PERSON",
                        selected: selectedType.value=='PERSON'
                      }, _toDisplayString(_ctx.$t('organizations.person')), 9, _hoisted_97)
                    ], 32)
                  ])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t('organizations.maxPayoutAmount')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formValues.maxPayoutAmount) = $event)),
                        type: "number",
                        step: "0.01",
                        min: "0",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['maxPayoutAmount'] }]),
                        placeholder: _ctx.$t('organizations.maxPayoutAmountPlaceholder'),
                        onBlur: _cache[24] || (_cache[24] = ($event: any) => (validate('maxPayoutAmount'))),
                        onKeyup: _cache[25] || (_cache[25] = ($event: any) => (validate('maxPayoutAmount')))
                      }, null, 42, _hoisted_101), [
                        [_vModelText, formValues.maxPayoutAmount]
                      ]),
                      _createElementVNode("span", _hoisted_102, _toDisplayString(errorsBis['maxPayoutAmount']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.$t('organizations.payoutValidationDelay')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((formValues.payoutValidationDelay) = $event)),
                        type: "number",
                        min: "0",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['payoutValidationDelay'] }]),
                        placeholder: _ctx.$t('organizations.payoutValidationDelayPlaceholder'),
                        onBlur: _cache[27] || (_cache[27] = ($event: any) => (validate('payoutValidationDelay'))),
                        onKeyup: _cache[28] || (_cache[28] = ($event: any) => (validate('payoutValidationDelay')))
                      }, null, 42, _hoisted_105), [
                        [_vModelText, formValues.payoutValidationDelay]
                      ]),
                      _createElementVNode("span", _hoisted_106, _toDisplayString(errorsBis['payoutValidationDelay']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("div", _hoisted_108, [
                    _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.$t('organizations.description')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((formValues.description) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['description'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('organizations.descriptionPlaceholder'),
                        onBlur: _cache[30] || (_cache[30] = ($event: any) => (validate('description'))),
                        onKeyup: _cache[31] || (_cache[31] = ($event: any) => (validate('description')))
                      }, "                    ", 42, _hoisted_110), [
                        [_vModelText, formValues.description]
                      ]),
                      _createElementVNode("span", _hoisted_111, _toDisplayString(errorsBis['description']), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_112, [
              (_unref(current_permissions)('create_organization'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_113, [
                    _cache[46] || (_cache[46] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('organizations.save')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _cache[47] || (_cache[47] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})